// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper___c3xI","col":"styles_col__1JiPl","fulfillmentStatus":"styles_fulfillmentStatus__3sk6o","emailCol":"styles_emailCol__sSNqT"};